import styled from "styled-components";

export const ChecklistCard = styled.div`
  background: white;
  padding: .5rem;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  width: 300px;
  max-height: 40vh;
  display: flex;
  flex-direction: column;
  position: absolute;
  /* right: 20rem; */
  right: 5rem;
  top: 18rem;
  z-index: 10;
`

export const ScrollableContainer = styled.div`
  overflow-y: auto;
  padding-right: 0.5rem;
  margin-right: -0.5rem;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
    
    &:hover {
      background: #a0aec0;
    }
  }

  /* Firefox scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 #f1f1f1;
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: .1rem;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f7fafc;
  }
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const StyledCheckbox = styled.div<{ checked: boolean }>`
  display: inline-block;
  width: 18px;
  height: 18px;
  background: ${props => props.checked ? '#0090D3' : '#fff'};
  border: 2px solid ${props => props.checked ? '#0090D3' : '#cbd5e0'};
  border-radius: 6px;
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  &:after {
    content: '';
    position: absolute;
    display: ${props => props.checked ? 'block' : 'none'};
    left: 4px;
    width: 4px;
    top: 1px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`

export const Label = styled.label`
  margin-left: 1rem;
  color: #4a5568;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
`